import { useMemo } from 'react';
import { AVAILABILITY } from '@/constants/product';
import { STORE_ID } from '@/constants/stores';

export function useOrderFiltersOptions(orders, t, storeId) {
  const orderStatusOptions = useMemo(() => {
    const statuses = [
      ...new Set(orders?.map((o) => o.status))
    ].sort();

    return [
      { value: '', label: t('account.orders.filters.all') },
      ...statuses.map((letter) => ({
        value: letter,
        label: t(`account.orders.status.${letter}`)
      }))
    ];
  }, [orders]);

  const orderTypeOptions = useMemo(() => {
    const types = [{ value: '', label: t('account.orders.filters.all') }];

    if (orders?.filter((o) => !o.isPrimeur && !o.isPrearrival).length) {
      types.push({ value: AVAILABILITY.LETTERS.IN_STOCK, label: t(`product.availability.short.${AVAILABILITY.LETTERS.IN_STOCK}`) });
    }

    if (orders?.filter((o) => o.isPrimeur).length) {
      types.push({ value: AVAILABILITY.LETTERS.PRIMEUR, label: t(`product.availability.short.${AVAILABILITY.LETTERS.PRIMEUR}`) });
    }

    if (storeId === STORE_ID.USA && orders?.filter((o) => o.isPrearrival).length) {
      types.push({ value: AVAILABILITY.LETTERS.PREARRIVAL, label: t(`product.availability.short.${AVAILABILITY.LETTERS.PREARRIVAL}`) });
    }

    return types;
  }, [orders]);

  const orderDateOptions = useMemo(() => {
    const ordersYears = [
      ...new Set(orders?.map((o) => (new Date(o.orderDate)).getFullYear()))
    ].sort().reverse();

    return [
      { value: '', label: t('account.orders.filters.allOrders') },
      ...ordersYears.map((year) => ({ value: year, label: String(year) }))
    ];
  }, [orders]);

  return [
    orderStatusOptions,
    orderTypeOptions,
    orderDateOptions
  ];
}
